import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import { UserProvider } from './context/UserContext';

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('Elemento raiz não encontrado! Verifique o ID do elemento no HTML.');
} else {
  // Adicione uma classe de loading inicial
  rootElement.classList.add('react-loading');
  
  const root = ReactDOM.createRoot(rootElement);

  // Função para remover a classe de loading quando o React estiver pronto
  const removeLoadingClass = () => {
    rootElement.classList.remove('react-loading');
    rootElement.classList.add('react-loaded');
  };

  try {
    root.render(
      <React.StrictMode>
        <UserProvider>
          <App onRenderComplete={removeLoadingClass} />
        </UserProvider>
      </React.StrictMode>
    );
    
    // Fallback: remove a classe após um tempo
    setTimeout(removeLoadingClass, 1000);
    
  } catch (error) {
    console.error('Erro ao renderizar a aplicação:', error);
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center; color: red;">
        <h2>Erro ao carregar a aplicação</h2>
        <p>Recarregue a página ou tente novamente mais tarde.</p>
        <button onclick="window.location.reload()">Recarregar</button>
      </div>
    `;
  }
}